import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseApi = createApi({
	reducerPath: 'baseApi',
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.NEXT_PUBLIC_API_URL,
		prepareHeaders: () =>
			// headers, { getState }
			{
				// 	const token = (getState() as RootState).auth.token;
				// 	if (token) {
				// 		headers.set('authorization', `Bearer ${token}`);
				// 	}
				// 	return headers;
			},
	}),
	endpoints: () => ({}),
	keepUnusedDataFor: 0,
});
